<!--Loading Spinner-->
<div *ngIf="isProcessing">
  <app-spinner></app-spinner>
</div>
 <!-- Content Header (Page header) -->
 <section class="content-header">
    <div class="content-header">
       <div class="container-fluid">
         <div class="row mb-2">
           <div class="col-sm-6">
               <h3>Unpaid Duties</h3>
           </div>
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
               <li class="breadcrumb-item active">Unpaid Duties</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
   </div>
  <div class="row">
    <div class="col-md-8">
        <div class="row">
          <div class="col">
            <div class="col-md-4">

            </div>
          </div>
        </div>
    </div>
    <div class="col-md-4">
      <div class="row">
          <div class="col">
              <input type="text" class="form-control" placeholder="Search by Chassis Number, BL Number or Entry Number" (input)="onSearchTextChange($event)">
          </div>
      </div>
    </div>
  </div>

  </section>
     <!-- /.content-header -->
   <section class="content">
   <div class="container-fluid">
      <h5>Payment</h5>
      <hr>
      <form [formGroup]="dutyPayment" (ngSubmit)="handleSubmit()">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
              <label>Amount to pay:</label>
              <input type="text" class="form-control" placeholder="Amount Paid" [(ngModel)]="amountToPay" [ngModelOptions]="{standalone: true}" readonly>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
              <label>Payment Date:<span style="color:red;">*</span></label>
              <input type="date" formControlName="payment_date" class="form-control" placeholder="Payment Date" value="">

              <span *ngIf="submitted && dutyPayment.get('payment_date')?.hasError('required')" style="color:red"> <strong>Please enter or select payment date!</strong></span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Bank:<span style="color:red;">*</span></label>
            <select formControlName="bank_account" class="form-control">
                <option value="">Select</option>
                <option [value]="bank_account.id" *ngFor="let bank_account of bank_accounts">{{ bank_account.bank_name }}</option>
            </select>

            <span *ngIf="submitted && dutyPayment.get('bank_account')?.hasError('required')" style="color:red"> <strong>Please select a bank account!</strong></span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group" style="margin-top: 30px;">
            <button type="submit" class="btn btn-outline-success"><i class="fas fa-money-check" aria-hidden="true">&nbsp;</i>Pay Selected</button>
          </div>
        </div>
      </div>
      <div class="card">
          <div class="card-header">
            <h3 class="card-title">Select duties to pay</h3>
          </div>
          <!-- /.card-header -->
          <div class="card-body" style="overflow-x: auto;">
            <!--Error Message-->
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
              <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
              {{errorMessage}}
            </div>
            <!--Warning Message-->
            <div class="alert alert-warning alert-dismissible" role="alert" *ngIf="warningMessage">
              <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
              {{warningMessage}}
            </div>
             <!--Success Message-->
             <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
              <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
              {{successMessage}}
            </div>
            <table id="example1" class="table table-bordered table-hover" style="white-space: nowrap; width: auto; min-width: 100%;">
              <thead>
                <tr>
                    <th></th>
                    <th>Added On</th>
                    <th>Entry No.</th>
                    <th>BL No.</th>
                    <th>Make</th>
                    <th>Model</th>
                    <th>Chassis No.</th>
                    <th>Duty Amount</th>
                    <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let duty of unpaid_duties | searchDutyPayment: searchText | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count };">
                  <td>
                    <input type="checkbox" [checked]="isSelected(duty)" (change)="checkboxChange($event, duty,duty.amount_paid)">
                  </td>
                  <td>{{ duty.added_on | date: 'dd-MM-yyyy' }}</td>
                  <td>{{ duty.entry_no }}</td>
                  <td>{{ duty.bl_no }}</td>
                  <td>{{ duty.make }}</td>
                  <td>{{ duty.model }}</td>
                  <td>{{ duty.chassis_no }}</td>
                  <td>{{ duty.amount_paid | currency:'UGX ' }}</td>
                  <td>
                    <button type="button" class="btn btn-success btn-sm"
                            (click)="viewEntryAndAssessmentNotice(duty.entry_id)">
                      <i class="fas fa-paperclip" aria-hidden="true"></i>&nbsp;View Entry
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="7"><b>Total</b></td>
                  <td><b>{{unpaidDuty.total_unpaid_duty| currency:'UGX '}}</b></td>
                </tr>
              </tfoot>
            </table>
            <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
          </div>
          <!-- /.card-body -->
      </div>
    </form>
   </div>
   </section>
